import { OverlayType } from '../../constants/common'
import BaseConfig from './overlayBaseConfig'

export enum PPCalculationTypeEnum {
  standard,
  fibonacci,
}

export const PPCalculationTypeLabels = {
  [PPCalculationTypeEnum.standard]: 'Standard',
  [PPCalculationTypeEnum.fibonacci]: 'Fibonacci',
}

export type Options = {
  calculationType: PPCalculationTypeEnum
}
export interface Attrs extends Options {
  period?: string
  color: string
}

export class PPConfig extends BaseConfig {
  static type = OverlayType.Pp
  static abbreviation = 'pp'
  static label = 'Pivot Points'
  static shortLabel = 'Pivot Points'
  static description =
    "Pivot points are technical analysis calculations used to determine potential support and resistance levels. They are calculated based on the previous day's high, low, and closing prices. Traders often use pivot points to identify potential entry and exit points, as well as to set stop-loss and take-profit orders."

  static optionsOrder = ['calculationType'] as const
  static optionsLabels = { calculationType: 'Calculation Type' }
  static inputsOrder = ['calculationType', 'color'] as Array<keyof Omit<Attrs, 'period'>>
  static inputsLabels = { calculationType: 'Calculation Type', color: 'Color' }
  static calculatedValuesOrder = ['pivot', 'res1', 'res2', 'res3', 'sup1', 'sup2', 'sup3'] as const

  static calculatedValuesLabels = {
    pivot: 'Pivot',
    res1: 'Resistance 1',
    res2: 'Resistance 2',
    res3: 'Resistance 3',
    sup1: 'Support 1',
    sup2: 'Support 2',
    sup3: 'Support 3',
  }

  static defaultCalculatedValueOption = this.calculatedValuesOrder[0]
}
